export default "__VITE_ASSET__Dk_$NdxF__"